import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MsalProvider } from '@azure/msal-react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ReactFlowProvider } from 'reactflow';
import UserProvider from './context/UserContext/UserProvider';
import theme from './theme';
import NavbarProvider from './context/NavbarContext/NavbarProvider';
import msalInstance from './context/msalInstance';
import EmbedProvider from './context/EmbedContext/EmbedProvider';
import AppRoutes from './components/AppRoutes/AppRoutes';
import ChatbotProvider from './context/ChatbotContext/ChatbotProvider';
import BotStatusProvider from './context/BotStatusContext/BotStatusProvider';
import PreviewModeProvider from './context/PreviewModeContext/PreviewModeContextProvider';
import BotBuilderProvider from './context/BotBuilderContext/BotBuilderProvider';

function App(): React.ReactElement {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
      <MsalProvider instance={msalInstance}>
        <GoogleOAuthProvider
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
        >
          <ThemeProvider theme={theme}>
            <NavbarProvider>
              <HelmetProvider>
                <UserProvider>
                  <ChatbotProvider>
                    <BotBuilderProvider>
                      <ReactFlowProvider>
                        <PreviewModeProvider>
                          <BotStatusProvider>
                            <EmbedProvider>
                              <AppRoutes />
                            </EmbedProvider>
                          </BotStatusProvider>
                        </PreviewModeProvider>
                      </ReactFlowProvider>
                    </BotBuilderProvider>
                  </ChatbotProvider>
                </UserProvider>
              </HelmetProvider>
            </NavbarProvider>
          </ThemeProvider>
        </GoogleOAuthProvider>
      </MsalProvider>
    </LocalizationProvider>
  );
}

export default App;
